import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import Error from 'components/Error'
import PageHead from 'containers/PageHead'

import { initialHeaderRequest } from 'helpers/nextjsApiCall'
import { pageTitle } from 'helpers/localization'
import { serverSideRedirect } from 'helpers/utilities'

import ChangePassword from 'apps/Users/ResetPassword/Change'
import RequestResetPassword from 'apps/Users/ResetPassword/Request'

const ResetPasswordPageLoader = (props) => {
  const intl = useIntl()
  const headerData = {
    title: pageTitle(intl, 'resetPassword.pageTitle'),
    metaRobots: 'noindex, follow',
  }

  if (props.statusCode) {
    return <Error {...props} />
  }

  return (
    <>
      <PageHead headerData={headerData} />

      {(props.action === 'edit') ? (
        <ChangePassword {...props} />
      ) : (
        <RequestResetPassword {...props} />
      )}
    </>
  )
}

ResetPasswordPageLoader.getInitialProps = async (props) => {
  const headerResult = await initialHeaderRequest(props)

  if (headerResult.currentUser.isSignedIn) {
    serverSideRedirect(props.res, '/')
  }

  return {
    ...headerResult,
    action: props.query.action,
    skipDeferringStyles: true,
  }
}

ResetPasswordPageLoader.propTypes = {
  action: PropTypes.string,
  statusCode: PropTypes.number,
}

export default ResetPasswordPageLoader
